// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import { Tooltip } from '../tooltips';
import ThemeMode from '@/types/theme-mode';

type Props = {
  icon: string;
  onClick?: (event: React.MouseEvent) => void;
  tooltip?: string;
  className?: string;
  dark?: boolean;
  theme?: ThemeMode;
  tooltipClassName?: string;
  tooltipPlace?: 'top' | 'bottom' | 'left' | 'right';
  tooltipEffect?: 'float' | 'solid';
  disabled?: boolean;
  active?: boolean;
  round?: boolean;
  darker?: boolean;
  noBackground?: boolean;
  stopClickPropagation?: boolean;
  ariaLabel?: string;
  'aria-expanded'?: boolean;
  'aria-controls'?: string;
};

const IconButton = ({
  icon,
  onClick,
  className,
  tooltip,
  dark,
  theme,
  tooltipClassName,
  tooltipPlace,
  tooltipEffect,
  disabled,
  round,
  active,
  darker,
  noBackground,
  stopClickPropagation,
  ariaLabel,
  ...rest
}: Props) => {
  const classes = classNames('icon-button', `icon-${icon}`, className, {
    dark,
    [`${theme}`]: theme,
    disabled,
    round,
    active,
    darker,
    'no-bg': noBackground,
  });

  const handleClick = (event: React.MouseEvent) => {
    if (stopClickPropagation) {
      event.stopPropagation();
    }
    if (onClick) {
      onClick(event);
    }
  };

  const button = (
    <button
      disabled={disabled}
      type="button"
      className="icon-button-wrapper"
      onClick={disabled ? undefined : handleClick}
      aria-label={ariaLabel || tooltip}
      {...rest}
    >
      <i className={classes} />
    </button>
  );

  if (tooltip) {
    return (
      <Tooltip className={tooltipClassName} message={tooltip} place={tooltipPlace} effect={tooltipEffect}>
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default IconButton;
